import { render, staticRenderFns } from "./union.vue?vue&type=template&id=199b4a22"
import script from "./union.vue?vue&type=script&lang=js"
export * from "./union.vue?vue&type=script&lang=js"
import style0 from "./union.vue?vue&type=style&index=0&id=199b4a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports